/**
 * Cache store manager.
 */
export default class CacheStore {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.stores = {};
    }
    /**
     * Returns store.
     *
     * @param name Name.
     * @returns Map.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getStore(name) {
        this.stores[name] = this.stores[name] || new Map();
        return this.stores[name];
    }
}
//# sourceMappingURL=CacheStore.js.map